/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enums_Lesstatus_Concept3Inputs */

const nl_enums_lesstatus_concept3 = /** @type {(inputs: Enums_Lesstatus_Concept3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Concept`)
};

/**

* @param {Enums_Lesstatus_Concept3Inputs} inputs
* @param {{ locale?: "nl" }} options
* @returns {LocalizedString}
*/
const enums_lesstatus_concept3 = /** @type {((inputs?: Enums_Lesstatus_Concept3Inputs, options?: { locale?: "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enums_Lesstatus_Concept3Inputs, { locale?: "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return nl_enums_lesstatus_concept3(inputs)
});
export { enums_lesstatus_concept3 as "enums.LesStatus.Concept" }